<div class="frac-home-trucking-vendors">
  <sa-lmo-frac-home-card localStorageKey="home__trucking_vendor" [isLoading]="!frac">
    <header class="flex justify-between my-1 py-2">
      <div class="flex items-center">
        <img src="/assets/icons/truck-vendor-icon.svg" alt="trucking vendors" />
        <span class="text-xl font-medium">Trucking</span>
      </div>
      <div>
        <a
          *saAllowedAccountRoles="['admin', 'dispatcher']"
          [routerLink]="['./', 'lmo_frac_home_modal', 'trucking_vendor']"
          class="button-add"
          >Add</a
        >
      </div>
    </header>
    <div class="flow-root ml-2 mr-2">
      <table class="w-full">
        <colgroup>
          <col class="w-1/2" />
          <col class="w-1/4" />
          <col class="w-1/4" />
        </colgroup>
        <thead class="border-b-2 border-gray-400">
          <tr>
            <th scope="col" class="py-2 pl-2 text-left text-gray-700">Carrier</th>
            <th scope="col" class="py-2 text-right text-gray-700">Awarded</th>
            <th scope="col" class="py-2 pr-2 text-right text-gray-700">Current</th>
          </tr>
        </thead>
        <tbody *ngIf="fracClusterTruckingVendors$ | async; else loadingFctvs">
          <tr
            class="gridRows border-b-2 border-gray-400 cursor-pointer"
            *ngFor="let fctv of fracClusterTruckingVendors$ | async; trackBy: trackById"
            [saAllowedAccountRolesEnabledFor]="['admin', 'dispatcher']"
            [routerLink]="['./', 'lmo_frac_home_modal', 'trucking_vendor', 'manage', fctv.id]"
            saAutomatedSelector="fctv_list__row"
            [automatedName]="fctv.truckingVendorName"
          >
            <td class="py-2 pl-2">
              {{ fctv.truckingVendorName }}
            </td>
            <td class="py-2 text-right " saAutomatedSelector="fctv_list__allocation_percent">
              {{ fctv.allocationPercent }}%
            </td>
            <td
              class="py-2 pr-2 text-right actual-percent"
              saAutomatedSelector="fctv_list__actual_percent"
              *ngIf="isAwarded(fctv); else pending"
            >
              {{ fctv.currentTruckPoolAllocationPercent }}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #loadingFctvs>
      <div class="loading">
        <mat-spinner></mat-spinner>
      </div>
    </ng-template>

    <ng-template #pending>
      <div class="py-2 pr-2 text-right"><mat-spinner diameter="20"></mat-spinner></div>
    </ng-template>

    <footer *saAllowedAccountRoles="['admin', 'default', 'dispatcher', 'sandCoordinator']" class="my-2">
      <a
        class="upper okay"
        [routerLink]="['./', 'lmo_frac_home_modal', 'trucking_vendor', 'overflow_vendors']"
        saAutomatedSelector="fctv__overflow"
        >Overflow Vendors ({{ overflowCount$ | async }})</a
      >
    </footer>
  </sa-lmo-frac-home-card>
</div>
